import React, { FunctionComponent } from 'react';
import { useTabbedRoomListsContext, ChatTabType } from '../../contexts/tabbedRoomListsContext';

const ChatTabs: FunctionComponent = () => {
  const { activeTab, setActiveTab, coffeeChatsCount } = useTabbedRoomListsContext();

  return (
    <div className="tabs is-boxed is-fullwidth m-b-0 chat-tabs-custom">
      <ul>
        <li className={activeTab === ChatTabType.ALL ? 'is-active is-flex' : ''}>
          <a onClick={() => setActiveTab(ChatTabType.ALL)}>
            <span>All Chats</span>
          </a>
        </li>
        <li className={activeTab === ChatTabType.COFFEE ? 'is-active' : ''}>
          <a onClick={() => setActiveTab(ChatTabType.COFFEE)}>
            <span>Coffee Chats {coffeeChatsCount > 0 && coffeeChatsCount}</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ChatTabs;